export default {
    Auth: [
        {
            url: "/api/Auth",
            method: "POST",
            summary: "Post",
            parameters: [
                {
                    in: "body",
                    name: "email",
                    type: "string",
                    required: true,
                },
                {
                    in: "body",
                    name: "senha",
                    type: "string",
                    required: true,
                },
            ],
        },
        {
            url: "api/auth/verifyhash/:hash/:idUsuario",
            method: "GET",
            summary: "VerifyHash",
            parameters: [
                {
                    name: "hash",
                    in: "path",
                    type: "string",
                    required: true,
                },
                {
                    name: "idUsuario",
                    in: "path",
                    type: "string",
                    required: true,
                },
            ],
        },
        {
            url: "/api/auth/redefinepassword/:hash",
            method: "POST",
            summary: "UpdatePassword",
            parameters: [
                {
                    in: "body",
                    name: "Id_Usuario",
                    type: "string",
                    required: true,
                },
                {
                    in: "body",
                    name: "Senha",
                    type: "string",
                    required: true,
                },
                {
                    in: "path",
                    name: "hash",
                    type: "string",
                    required: true,
                },
            ],
        },
        {
            url: "/api/auth/forgotpassword",
            method: "POST",
            summary: "ForgotPassword",
            parameters: [
                {
                    in: "query",
                    name: "email",
                    type: "string",
                    required: true,
                },
            ],
        },
        {
            url: "/api/auth/Yconnect",
            method: "POST",
            summary: "YconnectLogin",
            parameters: [
                {
                    in: "body",
                    name: "UserName",
                    type: "string",
                    required: true,
                },
                {
                    in: "body",
                    name: "Senha",
                    type: "string",
                    required: true,
                }
            ],
        },
    ],
    Test: [
        {
            url: "api/testeusuario/last",
            method: "GET",
            summary: "Last",
            parameters: [
                {
                    in: "query",
                    name: "idUsuario",
                    type: "string",
                    required: true,
                },
            ],
        },
        {
            url: "api/testeusuario",
            method: "POST",
            summary: "Post",
            parameters: [
                {
                    in: "body",
                    name: "Data",
                    type: "string",
                    required: true,
                },
                {
                    in: "body",
                    name: "Id_Placement",
                    type: "int",
                    required: true,
                },
                {
                    in: "body",
                    name: "Id_Usuario",
                    type: "int",
                    required: true,
                },
            ],

        }
    ],
    Sessao: [
        {
            url: "api/sessao",
            method: "GET",
            summary: "Get",
            parameters: [
                {
                    in: "query",
                    name: "idTesteUsuario",
                    type: "string",
                    required: true,
                },
            ],
        },
    ],
    Usuario: [
        {
            url: "/api/usuario/:id",
            method: "GET",
            summary: "Get",
            parameters: [
                {
                    in: "path",
                    name: "id",
                    type: "string",
                    required: true,
                },
            ],
        },
        {
            url: "/api/usuario/getschool/:idUsuario",
            method: "GET",
            summary: "GetSchool",
            parameters: [
                {
                    in: "path",
                    name: "idUsuario",
                    type: "string",
                    required: true,
                },
            ],
        },
        {
            url: "/api/usuario/admin/:idUsuario",
            method: "GET",
            summary: "Admin",
            parameters: [
                {
                    in: "body",
                    name: "id",
                    type: "int",
                    required: false,
                },
                {
                    in: "body",
                    name: "email",
                    type: "string",
                    required: false,
                },
            ],
        },
        {
            url: "api/usuario/addInfoUser/:idUsuario",
            method: "POST",
            summary: "CreateTest",
            parameters: [
                {
                    in: "path",
                    name: "idUsuario",
                    type: "string",
                    required: false,
                },
                {
                    in: "body",
                    name: "Cidade",
                    type: "string",
                    required: false,
                },
                {
                    in: "body",
                    name: "Cod_Unidade",
                    type: "string",
                    required: false,
                },
                {
                    in: "body",
                    name: "Estado",
                    type: "string",
                    required: false,
                },
                {
                    in: "body",
                    name: "Nome",
                    type: "string",
                    required: false,
                },
            ],
        },
        {
            url: "/api/usuario",
            method: "POST",
            summary: "Save",
            parameters: [
                {
                    in: "query",
                    name: "idAluno",
                    type: "string",
                    required: false,
                },
                {
                    in: "query",
                    name: "nome",
                    type: "string",
                    required: false,
                },
                {
                    in: "query",
                    name: "email",
                    type: "string",
                    required: false,
                },
                {
                    in: "query",
                    name: "usuario",
                    type: "string",
                    required: false,
                },
                {
                    in: "query",
                    name: "perfil",
                    type: "int",
                    required: true,
                },
                {
                    in: "query",
                    name: "idUsuario",
                    type: "string",
                    required: false,
                },
            ],
        },
        {
            url: "api/usuario/infoUsuario",
            method: "GET",
            summary: "GetInfo",
            parameters: [
                {
                    in: "query",
                    name: "idTesteUsuario",
                    type: "string",
                    required: true,
                },
            ],
        },
    ],
    Unidades: [
        {
            url: "api/unidadeyazigi/citiesByState",
            method: "GET",
            summary: "GetCidades",
            parameters: [
                {
                    in: "query",
                    name: "estado",
                    type: "string",
                    required: true,
                },
            ],
        },
        {
            url: "api/unidadeyazigi/unitiesByStateAndCity",
            method: "GET",
            summary: "GetUnidades",
            parameters: [
                {
                    in: "query",
                    name: "cidade",
                    type: "string",
                    required: true,
                }, {
                    in: "query",
                    name: "estado",
                    type: "string",
                    required: true,
                },
            ],
        },
    ],
    Tela: [
        {
            url: "api/tela",
            method: "GET",
            summary: "Get",
            parameters: [
                {
                    in: "query",
                    name: "idTesteParte",
                    type: "string",
                    required: true,
                },
                {
                    in: "query",
                    name: "ordem",
                    type: "string",
                    required: true,
                },
            ],
        },
    ],
    ConfirmarEmail: [
        {
            url: "api/ConfirmarEmail",
            method: "PUT",
            summary: "Put",
            parameters: [
                {
                    in: "body",
                    name: "idUsuario",
                    type: "string",
                    required: true,
                },
            ],
        },
    ],
    Profile: [
        {
            url: "api/profile/:id",
            method: "GET",
            summary: "Get",
            parameters: [
                {
                    in: "path",
                    name: "id",
                    type: "string",
                    required: true,
                },
            ],
        },
        {
            url: "api/profile/:id",
            method: "PUT",
            summary: "Put",
            parameters: [
                {
                    in: "path",
                    name: "id",
                    type: "string",
                    required: true,
                },
                {
                    in: "body",
                    type: "json",
                    required: true,
                },
            ],
        },
    ],
    EnvioNotas: [
        {
            url: "/api/envionotas",
            method: "GET",
            summary: "Get",
            parameters: [
                {
                    in: "query",
                    name: "id_curso",
                    type: "int",
                    required: true,
                },
                {
                    in: "query",
                    name: "id_grupo",
                    type: "int",
                    required: true,
                },
            ],
        },
        {
            url: "/api/envionotas",
            method: "POST",
            summary: "SendScore",
            parameters: [
                {
                    in: "body",
                    name: "alunos_envio",
                    type: "array",
                    required: true,
                },
                {
                    in: "body",
                    name: "id_curso",
                    type: "int",
                    required: true,
                },
                {
                    in: "body",
                    name: "id_grupo",
                    type: "int",
                    required: true,
                },
                {
                    in: "body",
                    name: "nsu_estab",
                    type: "int",
                    required: true,
                },
                {
                    in: "body",
                    name: "ordem_etapa",
                    type: "int",
                    required: true,
                },
            ],
        },
    ],
    Acessibilidade: [
        {
            url: "/api/Acessibilidade/Salvar",
            method: "POST",
            summary: "Post",
            parameters: [
                {
                    in: "query",
                    name: "id_aluno",
                    type: "string",
                    required: true,
                },
                {
                    in: "query",
                    name: "contraste",
                    type: "string",
                    required: true,
                },
                {
                    in: "query",
                    name: "leitura",
                    type: "string",
                    required: true,
                },
            ],
        },
        {
            url: "/api/Acessibilidade/Buscar",
            method: "GET",
            summary: "Get",
            parameters: [
                {
                    in: "query",
                    name: "id_aluno",
                    type: "string",
                    required: true,
                },
            ],
        },
    ],
    Acesso: [
        {
            url: "/api/acesso",
            method: "GET",
            summary: "Get",
            parameters: [
                {
                    in: "query",
                    name: "id",
                    type: "string",
                    required: true,
                },
            ],
        },
        {
            url: "/api/Acesso/resetLogUsuario",
            method: "GET",
            summary: "ResetLogUsuario",
            parameters: [
                {
                    in: "query",
                    name: "apelido",
                    type: "string",
                    required: true,
                },
            ],
        },
    ],
    Aluno: [
        {
            url: "/api/aluno",
            method: "GET",
            summary: "ProfilePicture",
            parameters: [
                {
                    in: "query",
                    name: "alunoFoto",
                    type: "string",
                    required: true,
                },
            ],
        },
        {
            url: "/api/aluno/:id",
            method: "GET",
            summary: "Get",
            parameters: [
                {
                    in: "path",
                    name: "id",
                    type: "string",
                    required: true,
                },
            ],
        },
        {
            url: "/api/aluno/",
            method: "GET",
            summary: "Buscar",
            parameters: [
                {
                    in: "query",
                    name: "id",
                    type: "string",
                    required: true,
                },
                {
                    in: "query",
                    name: "opt",
                    type: "string",
                    required: true,
                },
            ],
        },
    ],
    Exercicio: [
        {
            url: "api/testeexercicio/save",
            method: "POST",
            summary: "Save",
            parameters: [
                {
                    in: "query",
                    name: "idUsuario",
                    type: "string",
                    required: true,
                },
                {
                    in: "query",
                    name: "isNext",
                    type: "bool",
                    required: true,
                },
                {
                    name: "teste",
                    in: "body",
                    type: "serialize",
                    required: true
                },
            ],
        },
    ],
    Idioma: [
        {
            url: "/api/idioma",
            method: "GET",
            summary: "Get",
        },
    ],
    Language: [
        {
            url: "/api/language/:id",
            method: "GET",
            summary: "Get",
            parameters: [
                {
                    in: "path",
                    name: "idUsuario",
                    type: "string",
                    required: true,
                },
            ],
        },
    ],
    User: [
        {
            url: "api/usuario",
            method: "POST",
            summary: "Post",
            parameters: [
                {
                    in: "body",
                    name: "Nome",
                    type: "string",
                    required: true
                },
                {
                    in: "body",
                    name: "Email",
                    type: "string",
                    required: true
                },
                {
                    in: "body",
                    name: "Senha",
                    type: "string",
                    required: true
                },
                {
                    in: "body",
                    name: "Telefone",
                    type: "string",
                    required: true
                },
                {
                    in: "body",
                    name: "Cidade",
                    type: "string",
                    required: true
                },
                {
                    in: "body",
                    name: "Data_nasc",
                    type: "string",
                    required: true
                },
                {
                    in: "body",
                    name: "Colegio",
                    type: "string",
                    required: false
                },
                {
                    in: "body",
                    name: "Empresa",
                    type: "string",
                    required: false
                },
                {
                    in: "body",
                    name: "Fl_receber_email",
                    type: "boolean",
                    required: true
                },
                {
                    in: "body",
                    name: "Id_perfil",
                    type: "int",
                    required: true
                },
            ]
        }
    ],
    TesteUsuario: [
        {
            url: "api/TesteUsuario/:id",
            method: "GET",
            summary: "Get",
            parameters: [
                {
                    in: "path",
                    name: "id",
                    type: "string",
                    required: true
                },
            ]
        },
        {
            url: "api/testeusuario/last",
            method: "GET",
            summary: "GetLastTest",
            parameters: [
                {
                    in: "query",
                    name: "idUsuario",
                    type: "string",
                    required: true
                },
            ]
        }
    ],
    TesteParte: [
        {
            url: "api/testeparte/:idTestPart",
            method: "GET",
            summary: "Get",
            parameters: [
                {
                    in: "path",
                    name: "idTestPart",
                    type: "string",
                    required: true
                },
            ]
        },
        {
            url: "api/testeparte/infoLastParte",
            method: "GET",
            summary: "GetInfoLastPart",
            parameters: [
                {
                    in: "query",
                    name: "idTesteUsuario",
                    type: "string",
                    required: true
                },
            ]
        },
        {
            url: "api/Parte",
            method: "GET",
            summary: "GetPart",
            parameters: [
                {
                    in: "query",
                    name: "versaoId",
                    type: "string",
                    required: true
                },
                {
                    in: "query",
                    name: "ordem",
                    type: "string",
                    required: true
                }
            ]
        },
        {
            url: "api/testeparte/scoreCategory",
            method: "GET",
            summary: "GetScoreCategory",
            parameters: [
                {
                    in: "query",
                    name: "idTesteParte",
                    type: "string",
                    required: true
                }
            ]
        },
    ],
    Questoes: [
        {
            url: "api/testeparte/questoes/corretas",
            method: "GET",
            summary: "Corretas",
            parameters: [
                {
                    in: "query",
                    name: "idTesteUsuario",
                    type: "string",
                    required: true
                },
            ]
        },
        {
            url: "api/testeparte/questoes/totalByParteTeste",
            method: "GET",
            summary: "Total",
            parameters: [
                {
                    in: "query",
                    name: "idTesteUsuario",
                    type: "string",
                    required: true
                },
            ]
        }
    ],
    Admin: [
        {
            url: "api/admin/filterTestes",
            method: "GET",
            summary: "GetTestsFilter",
            parameters: [
                {
                    in: "query",
                    name: "idTeste",
                    type: "string",
                    required: true
                },
                {
                    in: "query",
                    name: "nome",
                    type: "string",
                    required: true
                },
                {
                    in: "query",
                    name: "idioma",
                    type: "string",
                    required: true
                },
                {
                    in: "query",
                    name: "qtdElementos",
                    type: "number",
                    required: true
                },
                {
                    in: "query",
                    name: "codUnidadeYazigi",
                    type: "string",
                    required: true
                },
                {
                    in: "query",
                    name: "visualizado",
                    type: "boolean",
                    required: false
                },
                {
                    in: "query",
                    name: "pagina",
                    type: "string",
                    required: true
                },
                {
                    in: "query",
                    name: "dataInicio",
                    type: "string",
                    required: true
                },
                {
                    in: "query",
                    name: "dataFim",
                    type: "string",
                    required: true
                }
            ]
        },
        {
            url: "api/admin/teste/respostasTeste/:idTesteUser",
            method: "GET",
            summary: "respostas",
            parameters: [
                {
                    in: "path",
                    name: "idTesteUser",
                    type: "string",
                    required: false
                },
            ]
        }, {
            url: "api/admin/teste/visaoExercicios/:id",
            method: "GET",
            summary: "GetExercisesAnswer",
            parameters: [
                {
                    in: "path",
                    name: "id",
                    type: "string",
                    required: true
                },
                {
                    in: "query",
                    name: "idExercicio",
                    type: "string",
                    required: false
                }
            ]
        }
    ]
};
